const API_BASE = '/api/success-stories';

async function api(path, { method = 'GET', body } = {}) {
  const res = await fetch(`${API_BASE}${path}`, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: body ? JSON.stringify(body) : undefined,
    credentials: 'include',
  });
  if (!res.ok) throw new Error(await res.text());
  return res.json();
}

export const SuccessStoriesService = {
  // Public feed (published only) — used by the Home page section
  listPublic: (limit = 12) => api(`?limit=${limit}`),

  // Admin — full list including drafts
  listAdmin: () => api('/admin'),
  getStory: (id) => api(`/${id}`),

  create: (fields) => api('', { method: 'POST', body: fields }),
  update: (id, fields) => api(`/${id}`, { method: 'PUT', body: fields }),
  remove: (id) => api(`/${id}`, { method: 'DELETE' }),
};

export default SuccessStoriesService;
